export function shuffle(array) {
    return [...array].sort(() => Math.random() - 0.5);
}

// filter: Function to get object property value to apply unicity
export function unique(array, filter = null) {
    if(filter) {
        return [
            ...new Map(
                array.map(item => [filter(item), item]),
            ).values(),
        ];
    }
    return array.filter((value, index, self) => self.indexOf(value) === index);
}

export function flat(array) {
    let ret = [];
    for(let i = 0; i < array.length; i++) {
        if(Array.isArray(array[i])) {
            ret = ret.concat(flat(array[i]));
        } else {
            ret.push(array[i]);
        }
    }
    return ret;
}
